import prefill from '../prefill';
import t from '../../translation';

export default prefill({
  0: { text: t('none') },
  1: { text: t('blueFlower') },
  2: { text: t('greenFlower') },
  3: { text: t('pinkFlower') },
  4: { text: t('purpleFlower') },
  5: { text: t('orangeFlower') },
  6: { text: t('yellowFlower') },
  7: { text: t('hoopEarrings') },
  8: { text: t('goldEarringLeft') },
  9: { text: t('goldEarringRight') },
  10: { text: t('goldEarrings') },
  11: { text: t('whiteEarrings') },
  12: { text: t('blueEarrings') },
  13: { text: t('greenEarrings') },
  14: { text: t('redEarrings') },
  15: { text: t('pinkEarrings') },
  16: { text: t('purpleEarrings') },
});
